import React, { useEffect, useState } from "react";
import { registerLoadingCallback } from "../../api/apiClient";
import "./GlobalLoadingOverlay.css";

const GlobalLoadingOverlay = () => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Register callback to track loading state from API client
    const unregister = registerLoadingCallback((loading) => {
      setIsLoading(loading);
    });

    // Cleanup on unmount
    return () => {
      unregister();
    };
  }, []);

  if (!isLoading) {
    return null;
  }

  return (
    <div className="global-loading-overlay">
      <div className="global-loading-content">
        <div className="global-spinner"></div>
        <p className="global-loading-text">Loading...</p>
      </div>
    </div>
  );
};

export default GlobalLoadingOverlay;

